module.exports = __webpack_public_path__ + "img/5.Κεφαλονιά-min.0b4bfbc3.jpg";